import { cn } from "@/lib/utils";

type ProductImageProps = {
  src: string;
  alt: string;
  className?: string;
  /** Outer frame size — keeps every pouch tile the same */
  frameClassName?: string;
  imgClassName?: string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
};

/**
 * Uniform product media frame.
 * All pouches sit in the same aspect box with consistent padding + object-contain
 * so mixed source dimensions (landscape mockups vs square) still look aligned.
 */
export function ProductImage({
  src,
  alt,
  className,
  frameClassName,
  imgClassName,
  loading = "lazy",
  fetchPriority,
}: ProductImageProps) {
  return (
    <div
      className={cn(
        "relative aspect-[5/6] w-full overflow-hidden bg-secondary",
        frameClassName,
        className,
      )}
    >
      <img
        src={src}
        alt={alt}
        loading={loading}
        fetchPriority={fetchPriority}
        className={cn(
          "absolute inset-0 m-auto h-full w-full object-contain object-center p-4 md:p-5",
          imgClassName,
        )}
      />
    </div>
  );
}
